import { OLButton } from "OLButton";
import { FieldArray } from "formik";
import { useMessage } from "hooks/intl";
import { RewardType } from "types/tierSets";
import { Reward } from "./Reward";

interface Props {
  activeTier: number;
}

export const Rewards = ({ activeTier }: Props) => {
  const { message } = useMessage();

  return (
    <FieldArray
      name={`tiers[${activeTier}].rewards`}
      render={({ remove, push, form: { values } }) => {
        const { rewards } = values.tiers[activeTier];
        const areBenefitsAdded = rewards && rewards.length > 0;
        const maxBenefitCount = 10;
        const isBenefitCountMaxed = rewards.length >= maxBenefitCount;

        return (
          <>
            {areBenefitsAdded && (
              <>
                {rewards.map((_item: RewardType, index: number) => {
                  return (
                    <Reward
                      key={index}
                      activeTier={activeTier}
                      index={index}
                      remove={remove}
                    />
                  );
                })}
              </>
            )}
            <OLButton
              variant="outlined"
              data-test-id="add-benefit"
              disabled={isBenefitCountMaxed}
              onClick={() => {
                push({
                  name: "",
                  active: false,
                  value: null,
                  code: "",
                  startAt: "",
                  endAt: "",
                  labels: [],
                });
              }}
            >
              {message({ id: "addBenefit" })}
            </OLButton>
          </>
        );
      }}
    />
  );
};
